import React from 'react';
export function Navbar() {
  return <nav className="w-full bg-white border-b border-gray-100 px-4 sm:px-6 lg:px-8 h-20 flex items-center z-10 relative" data-id="element-44">
      <div className="max-w-7xl mx-auto w-full flex items-center" data-id="element-45">
        <a href="/" className="flex items-center gap-3 hover:opacity-80 transition-opacity focus:outline-none focus:ring-2 focus:ring-[#CC0000] focus:ring-offset-2 rounded-md p-1" aria-label="Zumpago Argentina Home" data-id="element-46">
          <img src="https://cdn.magicpatterns.com/uploads/gi395LRVfqZ9kjZMamTeFk/zumpago.png" alt="Zumpago Logo" className="h-10 w-auto object-contain" data-id="element-47" />
          <span className="text-2xl select-none" role="img" aria-label="Bandera de Argentina" data-id="element-48">
            🇦🇷
          </span>
        </a>
      </div>
    </nav>;
}